export default {"src":"/_next/static/media/blinkit.e06b5241.svg","height":60,"width":228,"blurWidth":0,"blurHeight":0};